<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-condition" title="Add New Condition" v-if="showButton" v-on:click="openConditionModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <b-modal v-model="openConditionModel" title="New Condition" size="lg" ok-title="Create Condition" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="conditionModal" :no-close-on-backdrop="true" scrollable>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.condition_name }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.condition_name}">
                    Condition Name: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="condition_name" v-model="condition.condition_name" :class="{'form-control': true, 'is-invalid': errors.condition_name}" placeholder="Enter Condition Name" />
                    <span v-if="errors.condition_name" class="text-danger">
                        <span v-for="error in errors.condition_name">{{ error }}</span>
                    </span>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
        },

        data: function() {
            return {
                loading: true,
                condition: {},
                openConditionModel: false,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            show(){
                this.openConditionModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.condition = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveCondition();
            },

            saveCondition() {
                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/condition', this.condition)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Condition Saved');

                    //Close the modal
                    this.$refs.conditionModal.hide();

                    //Return to main list?
                    this.$emit('conditionCreated', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    this.$emit('conditionFailed', null);
                })
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.conditionModal.$refs);
            //this.$refs.conditionModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>

<style scoped>
    .new-condition {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>